var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    {
      attrs: {
        buttons: _vm.more.buttons,
        parameters: _vm.parameters,
        permissions: _vm.permissions
      }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n        " + _vm._s(_vm.$l10n.__("Sociétés liées")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c(
          "div",
          { staticClass: "prelative" },
          [
            _c("preloader", {
              staticClass: "mt-3",
              attrs: { display: _vm.loading }
            }),
            _vm._v(" "),
            !_vm.loading && _vm.thirds.length > 0
              ? _c("div", { staticClass: "flex-column flex" }, [
                  _c(
                    "div",
                    [
                      _vm.activeThirds.length > 0
                        ? _c(
                            "section",
                            _vm._l(_vm.activeThirds, function(third) {
                              return _c(
                                "div",
                                { key: third.id, staticClass: "well mb-2" },
                                [
                                  _c("third-card", {
                                    attrs: {
                                      third: third,
                                      permissions: _vm.permissions
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.archivedThirds.length > 0
                        ? _c(
                            "section",
                            [
                              _c("h4", [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("Sociétés archivées"))
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.archivedThirds, function(third) {
                                return _c(
                                  "div",
                                  { key: third.id, staticClass: "well mb-2" },
                                  [
                                    _c("third-card", {
                                      attrs: {
                                        third: third,
                                        permissions: _vm.permissions
                                      }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.infiniteLoading
                        ? _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("common.actions.load_more"),
                              loading: _vm.loading
                            },
                            on: { click: _vm.fetch }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _c("div", [
                  !_vm.loading
                    ? _c("div", { staticClass: "placeholder" }, [
                        _c("p", [_vm._v(_vm._s(_vm.placeholder))])
                      ])
                    : _vm._e()
                ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }